import { ISwiperDataItem } from "../components/custom-swiper/index";
// 轮播图获取第一个元素的高度
export const getFirstElementHeight = (
  item: ISwiperDataItem,
  callback: (height: number) => void,
) => {
  const swiperDom = document.getElementById("swiper");
  const screenWidth = swiperDom?.clientWidth || 375;
  try {
    let height = parseFloat(((item?.height / item?.width) * screenWidth).toFixed(2));
    if (height > 467) {
      height = 467;
    }
    if (height < 211) {
      height = 211;
    }
    callback(height);
  } catch (error) {
    console.error(error);
  }
};
